import { Html } from '@react-three/drei'
import { FC } from 'react'
import { Vector3 } from 'three'

interface Props {
  position: Vector3
  rotationZ?: number
  color?: string
}

const LocationInformation: FC<Props> = ({ position: _position }) => {
  // const size = 6
  // const position = new Vector3(0, 0, size / 2)
  const points = []
  points.push(new Vector3(0, 0, 0))
  points.push(new Vector3(0, 0, 10))

  return (
    <group position={[0, 0, 10]} rotation={[0, 0, 0]}>
      <Html scale={[100, 100, 100]}>
        <div style={{ background: '#f00', color: 'white' }}>Hejsan</div>
      </Html>
    </group>
  )
}

export default LocationInformation
